import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

import {useElementSize} from '@vueuse/core';
import {onMounted, ref, watchEffect} from 'vue';
import {useStore} from './store';
import ErrorScreen from './view/ErrorScreen';
import LoadingScreen from './view/LoadingScreen';
import VisualiserScreen from './view/VisualiserScreen';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();

const containerRef = ref<HTMLElement | null>(null);
const {width, height} = useElementSize(containerRef);

watchEffect(() => {
    window.parent.postMessage({type: 'visualiser-resize', height: height.value}, '*');
});

onMounted(() => {
    store.preloadData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "containerRef",
    ref: containerRef,
    class: "visualiser-container"
  }, [
    _createVNode(_Transition, {
      name: "screen",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_unref(store).view === 'error')
          ? (_openBlock(), _createBlock(_unref(ErrorScreen), { key: "ErrorScreen" }))
          : (_unref(store).view === 'loading')
            ? (_openBlock(), _createBlock(_unref(LoadingScreen), { key: "LoadingScreen" }))
            : (_unref(store).view === 'visualiser')
              ? (_openBlock(), _createBlock(_unref(VisualiserScreen), { key: "VisualiserScreen" }))
              : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ], 512 /* NEED_PATCH */))
}
}

})